import { DocumentData, QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";
import { BaseData, toBoolean } from "./_global";

export interface Part extends BaseData {
  partNumber: string | null;
  toolType: string | null;
  toolClass: string | null;
  toolSeries: string | null;
  toolFamily: string | null;
  description: string | null;
  od: string | null;
  id: string | null; // This is not the Firestore document ID it is a measurement for size of part
  drift: string | null;
  wt: string | null;
  weight: string | null;
  grade: string | null;
  workingLength: string | null;
  overallLength: string | null;
  lengthClosed: string | null;
  lengthOpen: string | null;
  topConnection: string | null;
  bottomConnection: string | null;
  material: string | null;
  assemblyBoolean: boolean | null;
  deprecatedBoolean: boolean | null;
  disDesignedBoolean: boolean | null;
  notes: string | null;
  stockLevel_Func: number | null;
  status: string | null;
  inventoryType: string | null;
  drawingNumberOverride: string | null;
  reOrderPoint: number | null;
}

export class Part extends BaseData {
  constructor(data: Partial<Part>) {
    super(data);
    this.uid = data.partNumber || null;
    this.partNumber = data.partNumber || null;
    this.toolType = data.toolType || null;
    this.toolClass = data.toolClass || null;
    this.toolSeries = data.toolSeries || null;
    this.toolFamily = data.toolFamily || null;
    this.description = data.description || null;
    this.od = data.od || null;
    this.id = data.id || null;
    this.drift = data.drift || null;
    this.wt = data.wt || null;
    this.weight = data.weight || null;
    this.grade = data.grade || null;
    this.workingLength = data.workingLength || null;
    this.overallLength = data.overallLength || null;
    this.lengthClosed = data.lengthClosed || null;
    this.lengthOpen = data.lengthOpen || null;
    this.topConnection = data.topConnection || null;
    this.bottomConnection = data.bottomConnection || null;
    this.material = data.material || null;
    this.assemblyBoolean = toBoolean(data.assemblyBoolean) || null;
    this.deprecatedBoolean = toBoolean(data.deprecatedBoolean) || null;
    this.disDesignedBoolean = toBoolean(data.disDesignedBoolean) || null;
    this.notes = data.notes || null;
    this.stockLevel_Func = data.stockLevel_Func || null;
    this.reOrderPoint = data.reOrderPoint || null;
    this.status = data.status || null;
    this.inventoryType = data.inventoryType || null;
    this.drawingNumberOverride = data.drawingNumberOverride || null;
  }
}

export const partConverter = {
  toFirestore(part: Part): DocumentData {
    return { ...part };
  },
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): Part {
    const data = snapshot.data(options);
    return new Part(data);
  },
};
